<div class="eSparsh-payment-container">

    <div class="p-fluid p-formgrid top-card card">
        <div class="field md:col-4 col-12">
            <div class="grid-item">
                <p-dropdown [options]="divisonList" [(ngModel)]="selectedDivision"
                    (onChange)="onSelectDivision()" appendTo="body" placeholder="{{ 'Select Division'| translate }}"
                    optionLabel="Division_MI"></p-dropdown>
            </div>
        </div>
        <div class="field md:col-4 col-12">
            <div class="grid-item">
                <p-dropdown [options]="contractorList" [(ngModel)]="selectedContractor"
                    (onChange)="onSelectContractor()" appendTo="body" placeholder="{{ 'Select Contractor'| translate }}"
                    optionLabel="ContractorName"></p-dropdown>
            </div>
        </div>
    </div>

    <div *ngIf="showDetailTable" class="grid mt-2">
        <div class="col-12">
            <div class="card">
                <div class="dashboardTable">
                    <p-table #readyForPaymentTable [value]="lotTableData" dataKey="APP_ID" [rows]="10"
                        [paginator]="true" [globalFilterFields]="[
                        'Lot_No',
                        'AppCount',
                        'Centre_share_amt',
                        'State_share_amt',
                        'TopUp',
                        'TotalRecommendedAmt',
                        'CreatedDate',
                        'PFMSPaymentDate',
                        'ProgramCount',
                        'CAORemarks',
                        'LotStatus',
                        ]" responsiveLayout="scroll" [rowHover]="true" sortMode="multiple"
                        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                        [showCurrentPageReport]="true" [loading]="loading">
                        <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <!-- Left side -->
                                <div class="col-5">
                                    <h5 class="m-0 table-header-text">{{'e-Sparsh Payment Details'| translate}}</h5>
                                </div>
                                <!-- Middle section for buttons -->
                                <div class="col-4 d-flex  justify-content-between">
                                    <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh"
                                        class="p-button-info mx-1"></button>
                                </div>
                                <!-- Right side for search -->
                                <!-- <div class="col-3 d-flex align-items-center justify-content-end">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="readyForPaymentTable.filterGlobal($any($event.target).value, 'contains')"
                                            placeholder="{{'SEARCH'| translate}}" />
                                    </span>
                                </div> -->
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="Lot_No">{{'LOT_NO'| translate}}</th>
                                <th>{{'NO_OF_RECORDS'| translate}}</th>
                                <th>{{'CENTER_SHARE_AMOUNT'| translate}}</th>
                                <th>{{'STATE_SHARE_AMOUNT'| translate}}</th>
                                <th>{{'TOP_UP_AMOUNT'| translate}}</th>
                                <th>{{'TOTAL_AMOUNT'| translate}}</th>
                                <th>{{'CREATED_DATE'| translate}}</th>
                                <th>{{'PAYMENT_DATE'| translate}}</th>
                                <!-- <th>{{'CAO_REMARKS'| translate}}</th> -->
                                <th>{{'LOT_STATUS'| translate}}</th>
                                <th>{{'MB_DOCUMENT'| translate}}</th>
                                <th>{{'TAX_CALCULATION_AND_RECOVERY_SHEET'| translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr>
                                <td><button (click)="pmfsExport(product, '')" pButton pRipple type="button"
                                        label="{{product.Lot_No}}" class="p-button-text"></button></td>
                                <!-- <td>{{product.Lot_No}}</td> -->
                                <td>{{product.AppCount}}</td>
                                <td>{{product.Centre_share_amt}}</td>
                                <td>{{product.State_share_amt}}</td>
                                <td>{{product.TopUp}}</td>
                                <td>{{product.TotalRecommendedAmt}}</td>
                                <td>{{product.CreatedDate | date:'mediumDate'}}</td>
                                <td>{{product.PFMSPaymentDate | date:'mediumDate'}}</td>
                                <!-- <td>{{product.CAORemarks}}</td> -->
                                <td>{{product.LotStatus}}</td>
                                <td>
                                    <a *ngIf="product?.MBDocPath" style="cursor: pointer" icon="pi pi-eye" [href]="product?.MBDocPath" target="_blank">
                                        <button pButton type="button"
                                            class="p-button-rounded p-button-accent p-button-primary p-button-rounded"
                                            pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                                    </a>
                                </td>
                                <td>
                                    <a *ngIf="product?.TaxDocPath" style="cursor: pointer" icon="pi pi-eye" [href]="product?.TaxDocPath" target="_blank">
                                        <button pButton type="button"
                                            class="p-button-rounded p-button-accent p-button-primary p-button-rounded"
                                            pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                                    </a>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="flex">
                                <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{lotTableData ? lotTableData.length : 0 }}
                                    {{'Lot(s) created'| translate}}.
                                </p>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7">No Data found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog [(visible)]="addDialog" [modal]="true" [style]="{ width: '100%', height: '100%' }" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="hideDialog()">
    <div *ngIf="loading1" class="flex justify-content-center align-items-center">
        <p-progressSpinner styleClass="custom-spinner" ariaLabel="loading" strokeWidth="3" fill="#EEEEEE"
            animationDuration="1s"></p-progressSpinner>
        <h4>Loading...</h4>
    </div>
    <div *ngIf="!loading1" class="mi-survey-container">
        <div class="card dashboardTable">
            <div class="container">
                <!-- <div class="row mb-3"> -->
                    <!-- <div class="col-md-6">
                        <div class="input-group"> -->
                    <div class="p-fluid p-formgrid grid my-0">
                        <div class="field col-12 md:col-3 filter-dropdown">
                            <!-- <input type="text" class="form-control" pInputText placeholder="Search Vendors..."
                                [(ngModel)]="filterText" (input)="applyFilter()"> -->
                            <label style="margin-right:4px;">{{'Filter- Caste:'| translate }}</label>
                            <p-dropdown [options]="casteDespList" [(ngModel)]="selectedCasteToFilter" (onChange)="onSelectCaste()"
                                placeholder="{{'SELECT_A_CASTE'| translate}}" optionLabel="label" optionValue="data" [showClear]="true">
                            </p-dropdown>
                        </div>
                    </div>
                    <!-- <div class="field col-12 md:col-3">
                        <label style="margin-right:4px;">{{'Filter- Sanction:'| translate }}</label>
                        <p-dropdown [options]="sanctionTypeList" [(ngModel)]="selectedSanctionToFilter" (onChange)="onSelectSanction()"
                            placeholder="{{'Select Sanction Type'| translate}}" optionLabel="label" optionValue="data" [showClear]="true">
                        </p-dropdown>
                    </div> -->
                <!-- </div> -->

                <div *ngFor="let vendor of filteredVendors; let vendorIndex = index"
                    class="vendor-table-container mb-4">
                    <div class="vendor-header p-2 mb-2 bg-light">
                        <h5 class="mb-1">{{ vendor.vendorName }}</h5>
                        <div class="vendor-details">
                            <span class="me-3"><strong>GST NO:</strong> {{ vendor.gstNo }}</span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <span><strong>Pan Card No:</strong> {{ vendor.panNo }}</span>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <p-table [value]="vendor.items" styleClass="p-datatable-gridlines vendor-data-table"
                            [paginator]="true" [rows]="10" dataKey="APP_ID" [loading]="loading1"
                            responsiveLayout="scroll" [rowHover]="true">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Lot No.</th>
                                    <!-- <th>View Application</th> -->
                                    <th>Application No</th>
                                    <th>Farmer Name</th>
                                    <th>Farmer Type</th>
                                    <th>Village</th>
                                    <th>Block</th>
                                    <th>District</th>
                                    <th>Cate Description</th>
                                    <th>MI Type</th>
                                    <th>MI Area</th>
                                    <!-- <th>Farmer Share</th> -->
                                    <!-- <th>Credited Date</th> -->
                                    <th>Center Share Payment</th>
                                    <th>State Share Payment</th>
                                    <th>Top up</th>
                                    <th>Total Amount</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                                <tr>
                                    <td>{{ rowIndex + 1 }}</td>
                                    <td>{{ lotNo }}</td>
                                    <!-- <td>
                                        <button pButton pRipple pTooltip="{{'VIEW_APPLICATION' | translate}}"
                                            icon="pi pi-file" class="p-button-rounded p-button-accent mr-1 btnSize"
                                            (click)="selectFarmerApplication(item)"></button>
                                    </td> -->
                                    <td>{{ item.APP_ID }}</td>
                                    <td>{{ item.Name }}</td>
                                    <td>{{ item.FarmerType }}</td>
                                    <td>{{ item.Village }}</td>
                                    <td>{{ item.Block }}</td>
                                    <td>{{ item.District }}</td>
                                    <td>{{ item.Caste_Description }}</td>
                                    <td>{{ item.ProposedSystem }}</td>
                                    <td>{{ item.TotalArea }}</td>
                                    <!-- <td>{{ item.FarmerShareAmt | number }}</td> -->
                                    <!-- <td>{{ item.CreditedOnDateTime }}</td> -->
                                    <td>{{ item.LotCentre_share_amt | number }}</td>
                                    <td>{{ item.LotLotState_share_amt | number }}</td>
                                    <td>{{ item.TopUp | number }}</td>
                                    <td>{{ calculateTotal(item) | number }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <tr>
                                    <td colspan="10" class="text-end fw-bold">Vendor Totals:</td>
                                    <td class="fw-bold">{{ getVendorTotalArea(vendor) | number:'1.2-2' }}</td>
                                    <!-- <td class="fw-bold">{{ getVendorTotalFarmerShare(vendor) | number:'1.2-2' }}</td> -->
                                    <!-- <td></td> -->
                                    <td class="fw-bold">{{ getVendorTotalCenterShare(vendor) | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getVendorTotalStateShare(vendor) | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getVendorTotalTopUp(vendor) | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getVendorTotalAmount(vendor) | number:'1.2-2' }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

                <div class="grand-totals p-3 mt-4 bg-light" *ngIf="filteredVendors.length > 0">
                    <div class="flex justify-content-center grand-total-header">
                        <p>{{ miCertificateData?.Program_Name }}</p>
                    </div>
                    <div class="table-responsive">
                        <p-table [value]="groupedVendors" styleClass="p-datatable-gridlines sanction-table">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5%">Sr. No.</th>
                                    <th style="width: 30%">Vendor Name</th>
                                    <th style="width: 10%">Beneficiary (No.)</th>
                                    <th style="width: 10%">Center Share Payment Amount</th>
                                    <th style="width: 10%">State Share Payment Amount</th>
                                    <th style="width: 10%">Top Up</th>
                                    <th style="width: 15%">Total Amount</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                                <tr>
                                    <td>{{ rowIndex + 1 }}</td>
                                    <td>{{ item?.vendorName }}</td>
                                    <td>{{ item?.beneficiaryCount }}</td>
                                    <td>{{ getVendorTotalCenterShare(item) | number:'1.2-2' }}</td>
                                    <td>{{ getVendorTotalStateShare(item) | number:'1.2-2' }}</td>
                                    <td>{{ getVendorTotalTopUp(item) | number:'1.2-2' }}</td>
                                    <td>{{ getVendorTotalAmount(item) | number:'1.2-2' }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <tr>
                                    <td colspan="2" class="text-end fw-bold">Total</td>
                                    <td class="fw-bold">{{ getGrandTotalBeneficiaries() | number:'1.0-0' }}</td>
                                    <td class="fw-bold">{{ getGrandTotalCenterShare() | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getGrandTotalStateShare() | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getGrandTotalTopUp() | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getGrandTotalAmount() | number:'1.2-2' }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                    <div class="header my-3 mx-5">
                        <div class="flex justify-content-start mx-0 my-3">
                            <p>It is certified that : -<br>
                                &nbsp;&nbsp;&nbsp; 1. The terms and conditions on the basis of which subsidy has proposed to be released have been fulfilled as per operational guidelines of PDMC scheme.<br>
                                &nbsp;&nbsp;&nbsp; 2. MI system installed is as per approved specification based on area specified by Farmers in their application and within approved cost/ estimate.<br>
                                &nbsp;&nbsp;&nbsp; 3. The benefit of scheme has extended to intended beneficiaries only one time and no payment were made earlier against these proposed application either to farmer or vendor.<br>
                                &nbsp;&nbsp;&nbsp; 4. The cases are submitted for first time for release of assistance.<br>
                                &nbsp;&nbsp;&nbsp; 5. The Farmer had deposited its 15% contribution as farmer share.<br>
                                &nbsp;&nbsp;&nbsp; 6. All required documents from both the vendors and beneficiary have been verified and uploaded on MI Portal.<br>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="alert alert-info mt-4" *ngIf="filteredVendors.length === 0">
                    <p> No vendor data available. </p>
                </div>
            </div>
        </div>

        <div class="" *ngIf="miCertificateData && selectedCasteToFilter">
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-3 filter-dropdown">
                    <label style="margin-right:4px;">{{'Filter- Sanction:'| translate }}</label>
                    <p-dropdown [options]="sanctionTypeList" [(ngModel)]="selectedSanctionToFilter" (onChange)="onSelectSanction()"
                        placeholder="{{'Select Sanction Type'| translate}}" optionLabel="label" optionValue="data" [showClear]="true">
                    </p-dropdown>
                </div>
            </div>
        </div>

        <div class="certificate-container" *ngIf="miCertificateData && selectedSanctionToFilter">
            <p-card styleClass="p-card-shadow">
                <div class="mt-2" id="printableArea">
                    <div class="print border bold" style="margin-top: 1px;">
                        <div class="flex align-items-center" style="display: flex; flex-direction: row; justify-content: center;">
                            <div style="flex: 0 0 auto;">
                                <img src="assets/activitiesImages/micada_new_logo.png" alt="MICADA Logo" width="100" height="70" class="mr-2 mt-1">
                            </div>
                            <div style="flex: 1 1 auto; text-align: center;">
                                <div class="mt-3 headings">
                                    <strong>{{'MICRO_IRR_COMP'| translate}}</strong><br>
                                    <strong>{{'HARYANA'| translate}}</strong><br>
                                    <strong>{{'FINANCIAL_YEAR_'| translate}}{{ selectedYear }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container mx-2 mt-3">
                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-between mx-5 my-3">
                                <p>Lot no. <b>{{ lotNo }}</b></p>
                                <p>Date the lot of print generated <b>{{ printGeneratedDate }}</b></p>
                            </div>
                        </div>

                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-center mx-5 my-3 certificate-header">
                                <p>ORDER</p>
                            </div>
                        </div>

                        <div class="header my-3 mx-5 text-justify">Sanction is hereby accorded for disbursement of
                            subsidy of Rs. <b>{{
                                getGrandTotalAmount() | number:'1.2-2' }}</b>
                            on a/c of installation of Micro Irrigation System <b>{{
                                miCertificateData?.Program_Name}}</b>
                            by the applicant farmer on farmer share basis to the registered vendors through E-Sparsh
                            portal as per GOI instructions from Centrally sponsored scheme code <b>{{
                                miCertificateData?.CenterSponsoredScheme }}</b>
                            and & State linked scheme code <b>{{ miCertificateData?.StateSponsoredScheme }}</b>.
                        </div>
                        <div class="header my-3 mx-5 text-justify">
                            Administrator MICADA been the competent authority had sanctioned the expenditure as per
                            details under: -
                        </div>


                        <div class="table-responsive">
                            <p-table [value]="groupedVendors" styleClass="p-datatable-gridlines sanction-table">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width: 5%">Sn.</th>
                                        <th style="width: 25%">Name of Payee</th>
                                        <th style="width: 15%">Particular</th>
                                        <th style="width: 10%">Lot No.</th>
                                        <th style="width: 25%">E-office No. & Dated</th>
                                        <th style="width: 10%">Beneficiary (No.)</th>
                                        <th style="width: 10%">Total</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                                    <tr>
                                        <td>{{ rowIndex + 1 }}</td>
                                        <td>{{ item?.vendorName }}</td>
                                        <td>Disbursement of Subsidy</td>
                                        <td>{{lotNo}}</td>
                                        <td>{{ item?.caoRemarks }}</td>
                                        <td>{{ item?.beneficiaryCount }}</td>
                                        <td>{{ getSanctionWiseAmount(item) | number:'1.2-2' }}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="footer">
                                    <tr>
                                        <td colspan="5" class="text-end fw-bold">Total</td>
                                        <td class="fw-bold">{{ getGrandTotalBeneficiaries() | number:'1.0-0' }}</td>
                                        <td class="fw-bold">{{ getGrandTotalSanctionWiseAmount() | number:'1.2-2' }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>

                        <div class="header my-3 mx-5 text-justify">
                            The expenditure will be met out for the budget the head for F.Y. <b>{{
                                miCertificateData?.FinancialYear}}</b>.
                        </div>

                        <div class="header my-3 mx-5 text-justify">
                            <em>“Implementation of Pradhan Mantri Krishi Sinchayee Yojana- Per Drop More Crop”</em>
                            &nbsp; <b>{{ selectedCasteToFilter }}</b> &nbsp; Under Head <b>{{
                                miCertificateData?.PMKSYId}}</b>.
                        </div>

                        <br><br><br>
                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-end mx-5 my-3">
                                <p>
                                    Engineer-in-Chief<br>
                                    Irrigation & W.R. Deptt.<br>
                                    Cum-Administrator, MICADA<br>
                                    Haryana (SNA-SPARSH)
                                </p>
                            </div>
                        </div>

                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-between mx-5 my-3">
                                <p>Endst. No./MICADA/<b>{{ miCertificateData?.eNo }}</b></p>
                                <p>Dated:- <b>{{ printGeneratedDate }}</b></p>
                            </div>
                        </div>


                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-start mx-0 my-3">
                                <p>A copy is forwarded to the following for information and n/a please: -<br>
                                    &nbsp;&nbsp;&nbsp; 1. The Principal Accountant General (A&E), Haryana,
                                    Chandigarh.<br>
                                    &nbsp;&nbsp;&nbsp; 2. Treasury Officer, Cyber Treasury, Panchkula.<br>
                                    &nbsp;&nbsp;&nbsp; 3. Chief Accounts Officer, MICADA for making payment through
                                    E-Sparsh Portal. (Two copies)<br>
                                    &nbsp;&nbsp;&nbsp; 4. Xen (Drainage) H.Q. Panchkula of Irrigation & Water Resources
                                    Dept. (SNA- Sparsh) being DDO (PDMC- PMKSY).<br>
                                </p>
                            </div>
                        </div>

                        <br><br><br>
                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-end mx-5 my-3">
                                <p> Director (MI)<br>
                                    For Administrator <br>
                                    MICADA, Panchkula
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </p-card>
        </div>

        <div class="card" *ngIf="miCertificateData && selectedSanctionToFilter">
            <h5><b>{{'TOTAL_NO_OF_APPLICATIONS_FILTERED_FOR_MI_SUBSIDY_TO_VENDOR_LOT' | translate}}: {{
                    appDataLotWise?.length }}</b>
            </h5>
            <div class="flex justify-content-end">
                <p-splitButton [model]="appVerificationItems" icon="pi pi-download"
                    label="{{'EXPORT' | translate}}"></p-splitButton>
            </div>
        </div>
    </div>

</p-dialog>